import { NEWBUILDING_WINNER_EXPERIMENT, NEWBUILDING_PRICE_PLATE_EXPERIMENT } from 'shared/selectors/abExperiments';
import { NEWBUILDING_TRUST_AND_SAFETY } from 'shared/selectors/abExperiments/selectIsNewbuildingReliabilityEnabled';

import { CALLTRACKING_WARNING } from '../../experiments/calltrackingWarning';
import { HOUSE_CARD_URL_EXPERIMENT } from '../../utils/experiments/houseCardUrl';

export const AA_TEST_50 = 'aud_desktop_aud2904_split_50_card_aa_expf';
export const AA_TEST_30 = 'aud_desktop_aud2904_split_30_card_aa_expf';

export const NEWBUILDING_AA_TEST_50 = 'newbuiliding_test_for_expf_desktop_50_50';
export const NEWBUILDING_AA_TEST_30 = 'newbuiliding_test_for_expf_desktop_70_30';

export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';

export const EXPERIMENTS: string[] = [
  HOUSE_CARD_URL_EXPERIMENT,
  CALLTRACKING_WARNING,
  NEWBUILDING_WINNER_EXPERIMENT,
  NEWBUILDING_PRICE_PLATE_EXPERIMENT,
  AA_TEST_50,
  AA_TEST_30,
  NEWBUILDING_AA_TEST_50,
  NEWBUILDING_AA_TEST_30,
  NEWBUILDING_TRUST_AND_SAFETY,
  AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT,
];
